import { Route, Routes } from "react-router-dom";
import HomePage from "../../pages/home/HomePage";
import VideoConversionPage from "../../pages/video-conversion/VideoConversionPage";
import VideoAnalysisPage from "../../pages/video-analysis/VideoAnalysisPage";
import VideoSegmentationPage from "../../pages/video-segmentation/VideoSegmentationPage";
import ShopPage from "../../pages/shop/ShopPage";
import ShopUsagePage from "../../pages/shop/ShopHistoryPage";
import MyAccountPage from "../../pages/my-account/MyAccountDetailsPage";
import MyAccountEditPage from "../../pages/my-account/MyAccountEditPage";
import OcrServicePage from "../../pages/ocr-service/OcrServicePage";
import AnalysisAndSegmentationPage from "../../pages/analysis-and-segmentation/AnalysisAndSegmentationPage";
import AnalysisAndOcrPage from "../../pages/analysis-and-ocr/AnalysisAndOcrPage";
import RestoreDataPage from "../../pages/restore-data/RestoreDataPage";
import { featureFlagsStorage } from "e.sic-platform.webclient/src/services/feature-flags/FeatureFlagsStorage";
import { Flags } from "e.sic-platform.webclient/src/generated/FeatureFlags";

export default function Routing() {
    return (
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/my-account" element={<MyAccountPage />} />
        <Route path="/my-account/edit" element={<MyAccountEditPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/app-usage" element={<ShopUsagePage />} />
        {featureFlagsStorage.isFeatureEnabled(Flags.Enable_Video_Conversion) && <Route path="/video-conversion" element={<VideoConversionPage />} />}
        {featureFlagsStorage.isFeatureEnabled(Flags.Enable_Video_Analysis) && <Route path="/video-analysis" element={<VideoAnalysisPage />} />}
        {featureFlagsStorage.isFeatureEnabled(Flags.Enable_Video_Segmentation) && <Route path="/video-segmentation" element={<VideoSegmentationPage />} />}
        {featureFlagsStorage.isFeatureEnabled(Flags.Enable_Ocr) && <Route path="/inspection-insights" element={<OcrServicePage />} />}
        {featureFlagsStorage.isFeatureEnabled(Flags.Enable_Ocr_Analysis) && <Route path="/analysis-and-inspection-insights" element={<AnalysisAndOcrPage />} />}
        {featureFlagsStorage.isFeatureEnabled(Flags.Enable_Analysis_And_Segmentation) && <Route path="/analysis-and-segmentation" element={<AnalysisAndSegmentationPage />} />}
        <Route path="/restore-esic-data" element={<RestoreDataPage />} />
      </Routes>
    );
}